<h2 mat-dialog-title>Búsqueda de {{'Cuenta' | translate}}</h2>

<div mat-dialog-content>

  <mat-expansion-panel [expanded]="true">

    <mat-expansion-panel-header>
      <mat-panel-title class="card-subtitulo">
        <mat-icon style="margin-top: -3px;">search</mat-icon> Selección de Propietario de Cuenta
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-tab-group>

      <mat-tab label="{{'Persona' | translate}}" *ngIf="canAsociarPersona">

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff; padding: 15px 15px 0px 15px; margin: 15px;">
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <button mat-raised-button (click)="onPersonSearchClick()" [disabled]="isProcessing()" color="accent" class="zb-button" style="margin-right: 10px;">
                  Buscar Datos de Persona Existente
                </button>

                <button mat-raised-button (click)="onNewPersonClick()" [disabled]="isProcessing()" class="zb-button" *ngIf="canPersonaAdd">
                  Agregar Datos de Persona
                </button>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="!(persona != null && persona.Id > 0) && !nuevaPersona" style="margin-top: 15px;">
          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>No hay ninguna persona seleccionada.</b></mat-label>
                </div>
              </mat-expansion-panel>
          </div>
        </div>

        <div fxLayout="row stretch" class="zb-readonly" *ngIf="persona != null && persona.Id > 0" style="margin-top: 15px;">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nombre</b>: {{persona?.Nombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Apellido</b>: {{persona?.Apellido}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Tipo Doc.</b>: {{persona?.TipoDocumentoNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nro. Doc.</b>: {{persona?.NroDocumento}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>CUIT</b>: {{persona?.Cuit}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Mail de Contacto</b>: {{persona?.MailContacto}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Móvil de Contacto</b>: {{persona?.MovilContacto}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Móvil de Contacto Opcional</b>: {{persona?.MovilContactoOtro}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

        <form [formGroup]="personaFormGroup" *ngIf="nuevaPersona && canPersonaAdd">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" maxlength="150">
                <mat-error *ngIf="!personaFormGroup.controls['Nombre'].valid && personaFormGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Apellido*</mat-label>
                <input matInput formControlName="Apellido" maxlength="150">
                <mat-error *ngIf="!personaFormGroup.controls['Apellido'].valid && personaFormGroup.controls['Apellido'].touched">
                  {{ getErrorApellido() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
                <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                  <mat-option>Ninguno</mat-option>
                  <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Documento</mat-label>
                <input matInput formControlName="NroDocumento" type="text" (change)="onNroDocumentoChange()" maxlength="100">
                <mat-error *ngIf="!personaFormGroup.controls['NroDocumento'].valid && personaFormGroup.controls['NroDocumento'].touched">
                  {{ getErrorNroDocumento() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="showCuit">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>CUIT/CUIL</mat-label>
                <input matInput formControlName="Cuit" type="number" (change)="onCuitChange()">
                <mat-error *ngIf="!personaFormGroup.controls['Cuit'].valid && personaFormGroup.controls['Cuit'].touched">
                  {{ getErrorCuit() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Nacimiento</mat-label>
                <input matInput [matDatepicker]="fechaNacimientoPicker" formControlName="FechaNacimiento" (click)="fechaNacimientoPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNacimientoPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaNacimiento')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaNacimientoPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Mail de Contacto</mat-label>
                <input matInput formControlName="MailContacto" maxlength="255">
                <mat-error *ngIf="!personaFormGroup.controls['MailContacto'].valid && personaFormGroup.controls['MailContacto'].touched">
                  {{ getErrorMailContacto() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Móvil de Contacto</mat-label>
                <input matInput formControlName="MovilContacto" maxlength="100">
                <mat-error
                  *ngIf="!personaFormGroup.controls['MovilContacto'].valid && personaFormGroup.controls['MovilContacto'].touched">
                  {{ getErrorMovilContacto() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

        </form>

      </mat-tab>

      <mat-tab label="{{'Proveedor' | translate}}" *ngIf="canAsociarProveedor">

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <form [formGroup]="proveedorFormGroup">
              <mat-form-field appearance="outline" style="width: 100%">
                <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                  [matAutocomplete]="proveedor" formControlName="Proveedor">
                <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                  class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor"
                (optionSelected)="onProveedorSelect()">
                <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                  {{s.RazonSocial}}
                </mat-option>
              </mat-autocomplete>
            </form>

          </div>

        </div>

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;" *ngIf="proveedor != null && proveedor?.Id > 0">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Razón Social</b>: {{proveedor?.RazonSocial}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>CUIT</b>: {{proveedor?.Cuit}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Activ. Princ.</b>: {{proveedor?.ActividadPrincipalNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>


        </div>

      </mat-tab>

      <mat-tab label="{{'Consorcio' | translate}}" *ngIf="canAsociarConsorcio">

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isConsorcioSearching">{{ 'Consorcio' | translate}}</mat-label>
              <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="consorcio" (selectionChange)="onConsorcioSelect()">
                <mat-option *ngFor="let s of consorcioList" [value]="s">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

        </div>

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;" *ngIf="consorcio != null && consorcio?.Id > 0">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nombre</b>: {{consorcio?.Nombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Razón Social</b>: {{consorcio?.RazonSocial}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>CUIT</b>: {{consorcio?.NroDocumento}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>{{'Tenant' | translate}}</b>: {{consorcio?.Tenant}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-tab>

      <mat-tab label="{{'Comunidad' | translate}}" *ngIf="canAsociarComunidad">

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isComunidadSearching">{{ 'Comunidad' | translate}}</mat-label>
              <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="comunidad" (selectionChange)="onComunidadSelect()">
                <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

        </div>

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;" *ngIf="comunidad != null && comunidad?.Id > 0">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nombre</b>: {{comunidad?.Nombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Tipo</b>: {{comunidad?.TipoNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Pisos</b>: {{comunidad?.CantidadPisos}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Consorcio</b>: {{comunidad?.Consorcio}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-tab>

      <mat-tab label="{{'UnidadFuncional' | translate}}" *ngIf="canAsociarUnidadFuncional">

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isComunidadSearching">{{ 'Comunidad' | translate}}</mat-label>
              <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="ufComunidad" (selectionChange)="onUfComunidadSelect()">
                <mat-option *ngFor="let s of ufComunidadList" [value]="s">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
              <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="unidadFuncional" (selectionChange)="onUnidadFuncionalSelect()">
                <mat-option *ngFor="let s of ufList" [value]="s">{{s.Codigo}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

        </div>

        <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;" *ngIf="unidadFuncional != null && unidadFuncional?.Id > 0">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Código</b>: {{unidadFuncional?.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Tipo</b>: {{unidadFuncional?.TipoUnidadNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>{{'Comunidad' | translate}}</b>: {{unidadFuncional?.Comunidad}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>{{'Consorcio' | translate}}</b>: {{unidadFuncional?.Consorcio}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </mat-expansion-panel>

  <ng-container *ngIf="!createNewCuenta && cuentaList != null">

    <hr style="margin: 10px 0px;">

    <mat-expansion-panel *ngIf="cuentaList.length > 1">

      <mat-expansion-panel-header>
        <mat-panel-title class="card-subtitulo">
          <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <form [formGroup]="searchForm">

        <div fxLayout="row stretch" fxLayout.xs="column">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-style">Moneda</mat-label>
              <mat-select class="text-style" formControlName="MonedaId">
                <mat-option class="text-style">Ninguna</mat-option>
                <mat-option class="text-style" *ngFor="let s of monedasList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

      </form>

      <div fxLayout="row stretch" fxLayout.xs="column">
        <mat-checkbox class="text-style" [(ngModel)]="verSoloCuentasConSaldo" (keyup.enter)="onSearch()" color="primary">Ver Solo Cuentas con Saldo</mat-checkbox>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="onSearch()" [disabled]="isCuentaSearching" color="primary" class="zb-button">{{isCuentaSearching ? 'Buscando...' : 'Buscar'}}</button>
      </div>

    </mat-expansion-panel>

    <br/>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;" *ngIf="isCuentaSearching">
      <mat-label><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    </div>

    <ng-container *ngIf="!isCuentaSearching">

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="monedaId > 0">
        <mat-label style="font-weight: bold;margin-bottom: 10px;">Listado de Cuentas en {{moneda}}:</mat-label>
      </div>
      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isCuentaSearching">
        <ejs-grid #grid [dataSource]='cuentaList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
          <e-columns>
            <e-column type="checkbox" field="Seleccionado" width="40"></e-column>
            <e-column field='Codigo' headerText='Código' width=120></e-column>
            <e-column field='Titular' headerText='Titular' width=80></e-column>
            <e-column field='ClaveBancaria' headerText='Identificador' width=120></e-column>
            <e-column field='Alias' headerText='Alias' width=120></e-column>
            <e-column field='BancoNombre' headerText='Banco' width=90></e-column>
            <e-column field='MonedaCodigo' headerText='Moneda' width=90 *ngIf="!(monedaId > 0)"></e-column>
            <e-column field='SaldoDisponible' headerText='Saldo' width=90 format="N2"></e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </ng-container>

  </ng-container>

  <ng-container *ngIf="createNewCuenta">

    <hr style="margin: 10px 0px; width: 100%;">

    <mat-expansion-panel [expanded]="true">

      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos de la Nueva Cuenta
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <form [formGroup]="formGroup">

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-label">Código</mat-label>
              <input class="text-label" matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100">
              <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                {{ getErrorCodigo() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Moneda</b>: {{moneda}}</mat-label>
              </div>
            </mat-expansion-panel>
            <!-- <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-label">Moneda*</mat-label>
              <mat-select class="text-label" formControlName="MonedaId">
                <mat-option class="text-label" *ngFor="let s of monedasList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['MonedaId'].valid && formGroup.controls['MonedaId'].touched">
                {{ getErrorMoneda() }}
              </mat-error>
            </mat-form-field> -->
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-label">CBU/CVU*</mat-label>
              <input class="text-label" matInput formControlName="ClaveBancaria" (keyup.enter)="onGuardar()" maxlength="100">
              <mat-error *ngIf="!formGroup.controls['ClaveBancaria'].valid && formGroup.controls['ClaveBancaria'].touched">
                {{ getErrorClaveBancaria() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label class="text-label">Alias*</mat-label>
              <input class="text-label" matInput formControlName="Alias" (keyup.enter)="onGuardar()" maxlength="100">
              <mat-error *ngIf="!formGroup.controls['Alias'].valid && formGroup.controls['Alias'].touched">
                {{ getErrorAlias() }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-label">Banco</mat-label>
                  <mat-select class="text-label" formControlName="BancoId">
                      <mat-option>Ninguno</mat-option>
                      <mat-option class="text-label" *ngFor="let s of bancosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-label">Número de Cuenta</mat-label>
                  <input class="text-label" matInput formControlName="NumeroCuenta" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error *ngIf="!formGroup.controls['NumeroCuenta'].valid && formGroup.controls['NumeroCuenta'].touched">
                      {{ getErrorNumeroCuenta() }}
                  </mat-error>
              </mat-form-field>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-label">Titular</mat-label>
                <input class="text-label" matInput formControlName="Titular" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Titular'].valid && formGroup.controls['Titular'].touched">
                    {{ getErrorTitular() }}
                </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item">
            <button mat-raised-button color="warn" (click)="onNewCuentaCancel()" class="zb-button">Cancelar Nueva Cuenta</button>
          </div>

        </div>

      </form>

    </mat-expansion-panel>

  </ng-container>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onNewCuentaClick()" *ngIf="!createNewCuenta" class="zb-button">Agregar Datos de Nueva Cuenta</button>
    <button mat-raised-button color="primary" (click)="onSelect()" class="zb-button">{{isSelecting ? 'Seleccionando...' : 'Seleccionar'}}</button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>
</div>
